
import Vue from 'vue';
import Lottie from '../Lottie.vue';
import * as confettiAppearingAnimation from '@/assets/animations/confetti-appearing.json';

export interface AnimationSettingsTypes {
  startAnimation: boolean;
  reverseAnimation: boolean;
  stopAnimation: boolean;
}

export default Vue.extend({
  components: {
    Lottie,
  },
  props: {
    width: {
      type: Number,
      default: 186,
    },
    height: {
      type: Number,
      default: 66,
    },
    animationSettings: {
      type: Object as Vue.PropType<AnimationSettingsTypes>,
      required: true,
    },
  },
  computed: {
    options() {
      return {
        loop: false,
        autoplay: false,
        speed: 3,
        animationData: confettiAppearingAnimation,
      };
    },
  },
});
